export const contentLoaderColors = {
  BACKGROUND_COLOR: '#f3f3f3',
  FOREGROUND_COLOR: '#ecebeb'
};
//# sourceMappingURL=constant.js.map